import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransfersService {
  constructor(private http: HttpClient) { }

  dropdownListStatus(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/v1/transfers/dropdown-list-status`)
  }

  add(transferParams: any, nextSeason = false): Observable<any> {
    const body = nextSeason ? { ...transferParams, next_season: true } : transferParams;
    return this.http.post(`${environment.apiUrl}/api/v1/transfers/add`, body)
  }

  drop(transferParams: any, nextSeason = false): Observable<any> {
    const body = nextSeason ? { ...transferParams, next_season: true } : transferParams;
    return this.http.post(`${environment.apiUrl}/api/v1/transfers/drop`, body)
  }

  switch(playerId: string, fromTeamId: string, toTeamId: string, transferStatusId: string, isCaptain: boolean, nextSeason = false): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/v1/transfers/switch`, {
      player_id: playerId,
      from_team_id: fromTeamId,
      to_team_id: toTeamId,
      transfer_status_id: transferStatusId,
      is_captain: isCaptain,
      ...(nextSeason && { next_season: true })
    })
  }

  transfers(searchedValue: string, nextSeason = false): Observable<any> {
    let url = `${environment.apiUrl}/api/v1/transfers?searched_value=${encodeURIComponent(searchedValue ?? '')}`;
    if (nextSeason) url += '&next_season=true';
    return this.http.get(url);
  }
}
